"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URL = void 0;
exports.API_URL = './api';
